<template>
  <div class="asc-fault-msg-bar-chart">
    <div class="asc-fault-msg-bar-chart--header">
      <asc-header
        class="asc-fault-msg-bar-chart--header-title"
        uppercase
        size="h4"
        :value="title"
      />
      <template v-if="tooltip.length">
        <asc-tooltip
          :tooltip="tooltip"
          bottom
          is-icon-tooltip
          :max-width="'300'"
          class="asc-fault-msg-bar-chart--header-tooltip"
        >
          <span class="asc-icon">
            <v-icon class="icon-info" :size="20">mdi-information</v-icon>
          </span>
        </asc-tooltip>
      </template>
    </div>

    <asc-fleet-bar-chart
      class="asc-fault-msg-bar-chart--container"
      :tails="tails"
      :loading="loading"
      :series-data="getSeries"
      :selected-item="selectedItem"
      :type="type"
      :multiple="multiple"
      :enable-drill="enableDrill"
      @onSeriesClick="handleRowClicked"
    ></asc-fleet-bar-chart>

    <template v-if="isTailsButtonDisplayed">
      <template v-if="showButton && !showAllTails && !loading">
        <div class="asc-fault-msg-bar-chart--all-tails-button">
          <asc-accent-button
            button-text="See All Tails"
            secondary
            :on-click="handleSeeAllTailsClicked"
            icon="mdi-chevron-down"
            icon-position="left"
          ></asc-accent-button>
        </div>
      </template>
      <template v-if="showButton & showAllTails && !loading">
        <div class="asc-fault-msg-bar-chart--all-tails-button">
          <asc-accent-button
            button-text="Collapse All Tails"
            secondary
            :on-click="handleCollapseAllTailsClicked"
            icon="mdi-chevron-up"
            icon-position="left"
          ></asc-accent-button>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import AscAccentButton from '../atoms/AscAccentButton.vue'
import variables from '@/styles/_varsJs.scss'
import AscTooltip from '@/components/atoms/AscTooltip'
import AscHeader from '@/components/atoms/AscHeader'
import AscFleetBarChart from './AscFleetBarChart.vue'

export default {
  name: 'AscFaultMsgBarChart',

  components: {
    AscAccentButton,
    AscTooltip,
    AscHeader,
    AscFleetBarChart,
  },

  props: {
    values: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    selectedItem: {
      type: [String, Array],
      default: '',
    },
    showButton: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      required: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    enableDrill: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      showAllTails: false,
      tails: [],
    }
  },

  computed: {
    getSeries() {
      return [
        {
          name: 'Flight Deck Effects',
          data: this.tails.length
            ? this.tails.map(item => item.flightDeckEffects)
            : [],
          color: '#265E5B',
        },
        {
          name: 'Correlated Maintenance Messages',
          data: this.tails.length
            ? this.tails.map(item => item.correlatedMaintenance)
            : [],
          color: variables.accent600,
        },
        {
          name: 'NonCorrelated Maintenance Messages',
          data: this.tails.length
            ? this.tails.map(item => item.nonCorrelatedMaintenance)
            : [],
          color: variables.accent300,
        },
        {
          name: 'Maintenance Memos',
          data: this.tails.length
            ? this.tails.map(item => item.maintenanceMemos)
            : [],
          color: variables.accent100,
        },
      ]
    },

    isTailsButtonDisplayed() {
      return this.values.length > 0
    },
  },

  watch: {
    values: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.tails = this.showAllTails ? newVal : newVal.slice(0, 15)
      },
    },
  },

  methods: {
    handleSeeAllTailsClicked() {
      this.showAllTails = true
      this.tails = this.values
    },

    handleCollapseAllTailsClicked() {
      this.showAllTails = false
      this.tails = this.values.slice(0, 15)
    },

    handleRowClicked(data, multiple) {
      this.$emit('onSeriesClick', data, multiple)
    },
  },
}
</script>

<style lang="scss">
.asc-fault-msg-bar-chart {
  .asc-fault-msg-bar-chart--all-tails-button {
    padding: 0 12px;
  }

  .asc-fault-msg-bar-chart--header-tooltip {
    margin-top: 2px;
  }

  .asc-accent-button-container .asc-accent-button--accent.theme--light.v-btn {
    width: 100%;
  }

  .asc-icon {
    display: inline-block;
    top: -2px;
    padding-left: $spacing-sm;
    position: relative;
  }

  .asc-icon .icon-info {
    color: $accent-500;
    cursor: pointer;
    display: inline-block;
    font-size: $font-size-lrg;
  }

  .asc-fault-msg-bar-chart {
    &--container {
      padding: 0 10px;
      height: 350px;
      overflow-y: auto;
    }

    &--header {
      display: flex;
      padding-top: 10px;
      padding-left: 10px;

      &-title {
        & .asc-header--h4 {
          font-size: 14px !important;
          font-weight: 500 !important;
          line-height: 20px !important;
          letter-spacing: 1px !important;
        }
      }
    }
  }
}
</style>
